import React from 'react'
import { useSnackbar } from 'notistack'

export const withSnackbar = (Component) => (props) => {
  const snackbar = useSnackbar()
  return <Component {...props} {...snackbar} />
}
